import React, { useState } from "react";
import "./world-map.css";
const WorldMap = require("react-world-map");
let WordlMap = () => {
  const [selected, onSelect] = useState(["sa"]);
  return (
    <div>
      <WorldMap
        className="map"
        selected={selected}
        onSelect={onSelect}
        multiple={true}
        onSelect={(continentCode) => {
          onSelect(continentCode);
        }}
        size="sm"
        aluePrefix="$"
      />
    </div>
  );
};
export default WordlMap;
